import DealListItemForSearch from "./DealListItemForSearch";
import DealListItemForSharing from "./DealListItemForSharing";

const DealListItem = ({ object, onClick, displayMode }) => {
  const DISPLAY_MODE_SHARINGS = "SHARINGS";

  if (displayMode == DISPLAY_MODE_SHARINGS)
    return <DealListItemForSharing deal={object} onClick={onClick} />;

  return <DealListItemForSearch deal={object} onClick={onClick} />;
};

export default DealListItem;
